import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const authData = useSelector((state) => state?.auth);
  if (authData?.isLogin) {
    return children;
  } else {
    return <Navigate to={"/"} />;
  }
};

export default PrivateRoute;
